import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'recompose';
import { Validator, WrappedFieldProps } from 'redux-form';

import FormInput from '../FormInput';
import asFormField from '../asFormField';
import FormField, { IClearableProps, IFormFieldGeneralProps } from '../FormField';
import { validateEmail, validateRequired } from '../../../utils/validators';
import IMPComponent from '../../interfaces/IMPComponent';

interface IEmailInputProps extends IFormFieldGeneralProps, IClearableProps {
  validate?: Validator | Validator[];
}

interface IEmailFieldProps extends IMPComponent, IFormFieldGeneralProps {
  name: string;
}

const EmailInput: React.FunctionComponent<IEmailInputProps> = asFormField()(
  (props: WrappedFieldProps & IFormFieldGeneralProps) => {
    return <FormField type="email" InputComponent={FormInput} {...props} />;
  },
);

class EmailField extends React.Component<IEmailFieldProps & InjectedIntlProps> {
  public render() {
    return <EmailInput clearable={true} {...this.props} validate={this.validate} />;
  }

  private validate: Validator = value => {
    const {
      intl: { formatMessage },
      label,
      required,
    } = this.props;

    if (required && !validateRequired(value)) {
      return formatMessage(
        {
          id: 'utils.validators.shared.required',
        },
        {
          label,
        },
      );
    }

    if (value && !validateEmail(value)) {
      return formatMessage(
        {
          id: 'utils.validators.validateEmail.invalidFormat',
        },
        {
          label,
        },
      );
    }

    return null;
  };
}

const enhance = compose<IEmailFieldProps & InjectedIntlProps, IEmailFieldProps>(injectIntl);

export default enhance(EmailField);



// WEBPACK FOOTER //
// ./src/components/Form/EmailField/index.tsx